addEventListener.removeEventListener = removeEventListener;
addEventListener.addEventListener = addEventListener;
module.exports = addEventListener;
var Events = null;

function addEventListener(el, eventName, listener, useCapture) {
  Events = Events || (document.addEventListener ? {
    add: stdAttach,
    rm: stdDetach
  } : {
    add: oldIEAttach,
    rm: oldIEDetach
  });
  return Events.add(el, eventName, listener, useCapture);
}

function removeEventListener(el, eventName, listener, useCapture) {
  Events = Events || (document.addEventListener ? {
    add: stdAttach,
    rm: stdDetach
  } : {
    add: oldIEAttach,
    rm: oldIEDetach
  });
  return Events.rm(el, eventName, listener, useCapture);
}

function stdAttach(el, eventName, listener, useCapture) {
  el.addEventListener(eventName, listener, useCapture);
}

function stdDetach(el, eventName, listener, useCapture) {
  el.removeEventListener(eventName, listener, useCapture);
}

function oldIEAttach(el, eventName, listener, useCapture) {
  if (useCapture) {
    throw new Error('cannot useCapture in oldIE');
  }

  el.attachEvent('on' + eventName, listener);
}

function oldIEDetach(el, eventName, listener, useCapture) {
  el.detachEvent('on' + eventName, listener);
}